import React from 'react';
import PropTypes from 'prop-types';
import { UserList } from 'src/components/AdminUsers/UserList.style.ts';

function UsersList({ users, onUserClick }) {
    users = users.sortBy(u => u.get('name'));

    return (
        <UserList className='admin-users__users-list'>
            {
                users.map(
                    u => (
                        <li key={ u.get('id') }>
                            <button
                                className={ `user user--${u.get('status')}` }
                                onClick={ () => onUserClick(u) }
                                data-test='admin-user-button'
                            >
                                { `${u.get('name')} (${u.get('status')})` }
                            </button>
                        </li>
                    )
                ).toArray()
            }
        </UserList>
    );
}

export default UsersList;
